<template>
    <div v-if="show" class="breakpoint-show">
        <div class="xs-only-show">xs</div>
        <div class="sm-only-show">sm</div>
        <div class="md-only-show">md</div>
        <div class="lg-only-show">lg</div>
        <div class="xl-only-show">xl</div>
    </div>
</template>

<script setup>
import { ref } from 'vue';


    const show =  ref((import.meta.env?.VITE_SHOW_BREAKPOINT ?? "false") === "true")

</script>

<style scoped></style>